(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tts-product-page-master-1"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tts-product-v1]').forEach((section) => {
    const variantData = section.querySelector('[data-product-variants]');
    const optionSelects = [...section.querySelectorAll('[data-option-index]')];
    if (variantData && optionSelects.length) {
      const variants = JSON.parse(variantData.textContent);
      const price = section.querySelector('[data-product-price]');
      const addButton = section.querySelector('[data-add-to-bag]');
      const installmentTerms = section.querySelector('shopify-payment-terms');
      const currency = section.dataset.currency;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency });
      const updateVariant = () => {
        const selections = optionSelects.map((select) => select.value);
        const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selections[index]));
        if (!variant) {
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.soldOutLabel;
          return;
        }
        section.querySelectorAll('input[name="id"]').forEach((input) => { input.value = String(variant.id); });
        const formattedPrice = formatter.format(variant.price / 100);
        if (price) price.textContent = formattedPrice;
        if (installmentTerms) installmentTerms.setAttribute('variant-id', String(variant.id));
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? `${addButton.dataset.addPrefix}${formattedPrice}` : addButton.dataset.soldOutLabel;
      };
      optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
      updateVariant();
    }
    const panels = [...section.querySelectorAll('[data-gallery-panel]')];
    const thumbs = [...section.querySelectorAll('[data-gallery-thumb]')];
    const current = section.querySelector('[data-gallery-current]');
    const track = section.querySelector('[data-gallery-track]');
    let activeIndex = 0;
    const select = (index) => {
      if (!panels.length) return;
      activeIndex = (index + panels.length) % panels.length;
      panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === activeIndex));
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === activeIndex);
        thumb.setAttribute('aria-current', thumbIndex === activeIndex ? 'true' : 'false');
      });
      if (current) current.textContent = String(activeIndex + 1);
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => select(Number(thumb.dataset.galleryThumb))));
    section.querySelector('[data-gallery-previous]')?.addEventListener('click', () => select(activeIndex - 1));
    section.querySelector('[data-gallery-next]')?.addEventListener('click', () => select(activeIndex + 1));
    if (track) {
      track.addEventListener('scroll', () => {
        if (window.innerWidth > 989 || !track.clientWidth) return;
        const index = Math.round(track.scrollLeft / track.clientWidth);
        activeIndex = Math.max(0, Math.min(index, panels.length - 1));
        if (current) current.textContent = String(activeIndex + 1);
      }, { passive: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tts-product-page-v1"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tts-product-v1]').forEach((section) => {
    const variantData = section.querySelector('[data-product-variants]');
    const optionSelects = [...section.querySelectorAll('[data-option-index]')];
    if (variantData && optionSelects.length) {
      const variants = JSON.parse(variantData.textContent);
      const price = section.querySelector('[data-product-price]');
      const addButton = section.querySelector('[data-add-to-bag]');
      const installmentTerms = section.querySelector('shopify-payment-terms');
      const currency = section.dataset.currency;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency });
      const updateVariant = () => {
        const selections = optionSelects.map((select) => select.value);
        const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selections[index]));
        if (!variant) {
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.soldOutLabel;
          return;
        }
        section.querySelectorAll('input[name="id"]').forEach((input) => { input.value = String(variant.id); });
        const formattedPrice = formatter.format(variant.price / 100);
        if (price) price.textContent = formattedPrice;
        if (installmentTerms) installmentTerms.setAttribute('variant-id', String(variant.id));
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? `${addButton.dataset.addPrefix}${formattedPrice}` : addButton.dataset.soldOutLabel;
      };
      optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
      updateVariant();
    }
    const panels = [...section.querySelectorAll('[data-gallery-panel]')];
    const thumbs = [...section.querySelectorAll('[data-gallery-thumb]')];
    const current = section.querySelector('[data-gallery-current]');
    const track = section.querySelector('[data-gallery-track]');
    let activeIndex = 0;
    const select = (index) => {
      if (!panels.length) return;
      activeIndex = (index + panels.length) % panels.length;
      panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === activeIndex));
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === activeIndex);
        thumb.setAttribute('aria-current', thumbIndex === activeIndex ? 'true' : 'false');
      });
      if (current) current.textContent = String(activeIndex + 1);
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => select(Number(thumb.dataset.galleryThumb))));
    section.querySelector('[data-gallery-previous]')?.addEventListener('click', () => select(activeIndex - 1));
    section.querySelector('[data-gallery-next]')?.addEventListener('click', () => select(activeIndex + 1));
    if (track) {
      track.addEventListener('scroll', () => {
        if (window.innerWidth > 989 || !track.clientWidth) return;
        const index = Math.round(track.scrollLeft / track.clientWidth);
        activeIndex = Math.max(0, Math.min(index, panels.length - 1));
        if (current) current.textContent = String(activeIndex + 1);
      }, { passive: true });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
